import { render } from "./SideNavItem.vue?vue&type=template&id=51ec7fca&scoped=true"
import script from "./SideNavItem.vue?vue&type=script&lang=js"
export * from "./SideNavItem.vue?vue&type=script&lang=js"

import "./SideNavItem.vue?vue&type=style&index=0&id=51ec7fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ec7fca"]])

export default __exports__